import { render, staticRenderFns } from "./PromoSelectSearch.vue?vue&type=template&id=49be894c&"
import script from "./PromoSelectSearch.vue?vue&type=script&lang=js&"
export * from "./PromoSelectSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports